// What went wrong where nothing was expected to, kept for whoever reads the
// log and never shown (INC-15b-3, C2, point 180, D-179).
//
// The sign in, the link a person asks for and the password a person chooses
// say in words that it did not go and to try again in a few minutes; the code
// the server answered, or the kind of failure that never reached it, goes to
// the browser's log with where it happened, where support reads it.
import { isApiError } from '../api/errors';

/** The code of a failure as the log carries it: the server's, or the name of
 *  what failed before any answer. */
export function failureCode(failure: unknown): string {
  if (isApiError(failure)) return failure.code;
  if (failure instanceof Error) return failure.name;
  return 'unknown';
}

/** Writes an unexpected failure to the log, in one line: where, its code and
 *  the status it came with, if it came with one. */
export function logUnexpected(where: string, failure: unknown): void {
  const status = isApiError(failure) ? `, status ${String(failure.status)}` : '';
  console.error(`${where}: unexpected failure, code ${failureCode(failure)}${status}`);
}
